import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFF",
      d: "M10.6.46.997 7.5A2.456 2.456 0 0 0 0 9.482v10.774C0 22.324 1.645 24 3.675 24h16.65C22.356 24 24 22.324 24 20.256V9.482c0-.786-.371-1.523-.997-1.982L13.4.46a2.36 2.36 0 0 0-2.8 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#743A3A",
      d: "M14.579 14.25c.617 0 1.118.51 1.118 1.139 0 .598-.452 1.088-1.027 1.135l-.091.004H9.476a1.13 1.13 0 0 1-1.118-1.14c0-.597.452-1.087 1.026-1.135l.092-.004h5.103Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "homes"}) } }